export default "__VITE_PUBLIC_ASSET__d6d35987__"